import { styled } from "@mui/material/styles";
import { Box, Button, Typography, Checkbox } from "@mui/material";
import { colors } from "../../constants/colors";

/**
 * ห้ามใส่ height: 100vh — กล่องที่ scroll จริงคือ .container-content (สูง 100vh - header)
 * ถ้าตรึง 100vh ไว้ เนื้อหาที่ยาวกว่านั้น (เช่นตาราง 100/1000 แถว) จะกลายเป็น overflow ที่ล้นออกนอกกล่อง
 * ซึ่ง padding-bottom ของตัว scroll (pb-5) ใช้กับส่วนที่ล้นไม่ได้ แถวสุดท้าย/pagination จึงชิดขอบล่างจนถูกตัด
 */
export const PageContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100%",
}));

export const MainContainer = styled("div")(({ theme }) => ({
  height: "100%",
  padding: 24,
}));

export const TableContainer = styled(Box)(({ theme }) => ({
  marginTop: "10px",
}));

export const ChartContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${colors.disabledLightGray}`,
  borderRadius: 8,
  marginTop: 10,
  width: "100%",
  padding: "0px 16px",
}));

export const CheckboxContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
}));

export const TitleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginTop: "10px",
  fontSize: 16,
  fontWeight: 400,
}));
